import React, { useEffect, useState } from "react";
import { Alert, AlertTitle, Collapse } from "@mui/material";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";

const PaymentAlert = () => {
  const dispatch = useDispatch();
  const { paymentStatus } = useSelector((state) => state.transportation);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("info");

  useEffect(() => {
    const today = dayjs();
    const day = today.date();

    if (!paymentStatus.paymentStatus) {
      if (day >= 5 && day <= 7) {
        setAlertType("warning");
        setShowAlert(true);
      } else if (day >= 8) {
        setAlertType("error");
        setShowAlert(true);
      }
    } else {
      setShowAlert(false);
    }
  }, [paymentStatus]);

  if (!showAlert) return null;

  return (
    <Collapse in={showAlert}>
      <Alert severity={alertType} sx={{ mb: 2 }}>
        <AlertTitle>
          {alertType === "warning"
            ? "Payment Reminder"
            : "Transport Facility Suspended"}
        </AlertTitle>
        {alertType === "warning" ? (
          <>
            Please note that the payment date is from{" "}
            <strong>5th to 7th</strong>. Make the payment before{" "}
            <strong>8th</strong>.
          </>
        ) : (
          <>
            You have not paid before the <strong>8th</strong>. You are no longer
            eligible for the transport facility.
          </>
        )}
      </Alert>
    </Collapse>
  );
};

export default PaymentAlert;
